import ListViewCtrl from "../../util/ListViewCtrl";
import TypPolozkyCennikaService from "./TypPolozkyCennikaService";

export default class TypPolozkyCennikaListCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "TypPolozkyCennikaService"];

  constructor(itemSource, TypPolozkyCennikaService){
    super(itemSource);

    console.log(itemSource);

    this.TypPolozkyCennikaService = TypPolozkyCennikaService;
  }

  onDeleteTypPolozkyClicked(index) {
    if (confirm('Naozaj odstrániť?')) {
      this.TypPolozkyCennikaService.delete(this.itemSource.result[index].id).then(() => {
        this.itemSource.result.splice(index, 1);
      })
    }
  }

}


// WEBPACK FOOTER //
// ./src/Cennik/TypPolozkyCennika/TypPolozkyCennikaListCtrl.js